import { useId, type SVGProps } from "react"

const CORES = {
  azul: "#1e3a6e",
  cinza: "#4a4b4f",
  ouro: "#b8955c",
  branco: "#ffffff",
}

export function Logotipo({
  monocromatico = false,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { monocromatico?: boolean }) {
  const azul = monocromatico ? "currentColor" : CORES.azul
  const cinza = monocromatico ? "currentColor" : CORES.cinza
  const ouro = monocromatico ? "currentColor" : CORES.ouro
  const branco = monocromatico ? "none" : CORES.branco
  const id = useId().replace(/[^a-zA-Z0-9_-]/g, "")
  const semDocumento = `logotipo-sem-documento-${id}`
  const dentroDoEscudo = `logotipo-dentro-do-escudo-${id}`
  const contornoDaLetra = `logotipo-contorno-da-letra-${id}`

  return (
    <svg
      data-slot="logotipo"
      viewBox="0 0 100 110"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...props}
    >
      <defs>
        <mask id={semDocumento} maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="110">
          <rect width="100" height="110" fill="#fff" />
          <path d="M42.6 41 H53.2 L57.4 45.2 V59 H42.6 Z" fill="#000" />
        </mask>
        <clipPath id={contornoDaLetra}>
          <path d="M47.6 26 C44 46 36 70 25 100 L75 100 C64 70 56 46 52.4 26 Z" />
        </clipPath>
        <clipPath id={dentroDoEscudo}>
          <path d="M50 3 L92 14 V52 C92 80 74 99 50 107 C26 99 8 80 8 52 V14 Z" />
        </clipPath>
      </defs>

      <path d="M50 9.5 L86.5 19 V52 C86.5 77 71 93.5 50 100.5 C29 93.5 13.5 77 13.5 52 V19 Z" fill={branco} />

      <path d="M50 14 L52.4 18.5 L50 23 L47.6 18.5 Z" fill={azul} />
      <path d="M50 22 V28" stroke={azul} strokeWidth={1.6} />
      <path d="M21 33 Q35.5 26 50 27" stroke={azul} strokeWidth={2.8} fill="none" strokeLinecap="round" />
      <path d="M50 27 Q64.5 26 79 33" stroke={cinza} strokeWidth={2.8} fill="none" strokeLinecap="round" />
      <circle cx="21" cy="33" r="2.3" fill={azul} />
      <circle cx="79" cy="33" r="2.3" fill={cinza} />
      <path d="M21 35 L14.5 53 M21 35 L27.5 53" stroke={azul} strokeWidth={1.1} fill="none" />
      <path d="M11.5 53 H30.5 Q21 63 11.5 53 Z" fill={azul} />
      <path d="M79 35 L72.5 53 M79 35 L85.5 53" stroke={cinza} strokeWidth={1.1} fill="none" />
      <path d="M69.5 53 H88.5 Q79 63 69.5 53 Z" fill={ouro} />

      <g clipPath={`url(#${dentroDoEscudo})`}>
        <g mask={`url(#${semDocumento})`}>
          <path d="M50 26 H47.6 C44 46 36 70 25 100.5 L38.5 104 C42 79 46.5 55 50 38 Z" fill={azul} />
          <path d="M50 26 H52.4 C56 46 64 70 75 100.5 L61.5 104 C58 79 53.5 55 50 38 Z" fill={cinza} />
        </g>
      </g>

      <path
        fillRule="evenodd"
        fill={azul}
        d="M50 3 L8 14 V52 C8 80 26 99 50 107 Z M50 9.5 L13.5 19 V52 C13.5 77 29 93.5 50 100.5 Z"
      />
      <path
        fillRule="evenodd"
        fill={cinza}
        d="M50 3 L92 14 V52 C92 80 74 99 50 107 Z M50 9.5 L86.5 19 V52 C86.5 77 71 93.5 50 100.5 Z"
      />

      <g>
        <path d="M44 42.5 H52.4 L56 46.1 V57.5 H44 Z" fill={branco} stroke={azul} strokeWidth={1.2} strokeLinejoin="round" />
        <path d="M52.4 42.5 V46.1 H56 Z" fill={azul} />
        <path d="M46.3 49.3 H53.7 M46.3 52 H53.7 M46.3 54.7 H50.6" stroke={azul} strokeWidth={1.1} strokeLinecap="round" />
      </g>

      <g clipPath={`url(#${contornoDaLetra})`}>
        <path d="M28 56.5 Q39 55.1 50 55 V60.5 Q39 60.6 28 62 Z" fill={azul} />
        <path d="M72 56.5 Q61 55.1 50 55 V60.5 Q61 60.6 72 62 Z" fill={cinza} />
      </g>
    </svg>
  )
}
